<template>
  <div
    v-if="name === 'name'"
    v-html="data"
  />

  <div
    v-else-if="name === 'status'"
    :style="{ background: data.color }"
    class="LKReportsRoadmapCommonTableItemEvent__color"
    v-text="data.label"
  />

  <div v-else-if="name === 'files'">
    <template v-if="data">
      <div
        v-for="file in data"
        :key="file.id"
        class="LKReportsRoadmapCommonTableItemEvent__link-container"
      >
        <a
          :href="file.url"
          :download="file.name"
          class="LKReportsRoadmapCommonTableItemEvent__link"
          v-text="file.name"
        />
      </div>
    </template>
  </div>

  <div
    v-else-if="name === 'is_confirmed'"
    :style="{ background: data.color }"
    class="LKReportsRoadmapCommonTableItemEvent__color"
    v-text="data.label"
  />

  <div
    v-else
    v-text="data"
  />
</template>

<script>
export default {
  name: 'LKReportsRoadmapCommonTableItemEvent',
  props: {
    name: {
      type: String,
      required: true,
    },
    data: {
      type: null,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.LKReportsRoadmapCommonTableItemEvent {
  &__color {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $color-white;
  }

  &__link {
    display: inline-block;
    color: $color-black;
    text-decoration-line: none;

    &:hover {
      text-decoration-line: underline;
    }

    &-container {
      margin-bottom: 6px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
